import sortByCreatedAtDesc from '../../data_management/sorters/sort_by_created_at_desc';

const CompletedInvestigations = function ($scope, $location, featureToggles, eventsService, ModalService, investigationInteractor) {
  const $ctrl = this;

  $ctrl.$onInit = function () {
    $scope.featureEnabled = (feature) => featureToggles.isAvailable(feature);
  };

  $ctrl.sortedInvestigations = function () {
    if ($ctrl.investigations)
      return $ctrl.investigations.sort(sortByCreatedAtDesc);
    else
      return [];
  };

  $ctrl.investigationsToDisplay = function () {
    return $ctrl.sortedInvestigations()
      .filter(investigation => !investigation.is_open && !investigation.is_archived)
      .slice(0, 50);
  };

  $ctrl.clickedLeftSection = function (investigation) {
    $scope.$applyAsync(() => $location.path(`/investigation/${investigation.id}`));
  };

  $ctrl.archiveInvestigation = function (investigation) {
    return investigationInteractor.archiveInvestigation(investigation).then(() => {
      eventsService.publishSystemMessage('Investigation has been archived');
      $scope.$digest();
    })
  };
};

export default {
  name: 'completedInvestigations',
  obj: {
    controller: CompletedInvestigations,
    templateUrl: 'components/completed_investigations.html',
    bindings: {
      investigations: '<'
    }
  },
  deps: []
}